import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { EmployeeForTable } from '../../types'
import { employeeForTableFromDTO } from './api/mapper'
import { GET_EMPLOYEES_FOR_TABLE } from './api/query'
import { Data, EmployeeForTableDTO, Variables } from './api/types'
import { UseGetEmployees, UseGetEmployeesProps } from './types'

export const useGetEmployees = ({
  filters,
  first,
  last,
}: UseGetEmployeesProps): UseGetEmployees => {
  const [users, setUsers] = useState<EmployeeForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async data => {
      const {
        users: { nodes: users, totalCount: count },
      } = data

      if (users) {
        setUsers(
          users.map((user: EmployeeForTableDTO): EmployeeForTable => employeeForTableFromDTO(user)),
        )
        setCount(count)
      }
    },
    query: GET_EMPLOYEES_FOR_TABLE,
    variables: {
      first,
      last,
      terms: filters,
      userGroup: 'employees',
    },
  })

  return {
    count,
    loading: isLoading,
    users,
  }
}
